// extracted by mini-css-extract-plugin
module.exports = {"card":"SimpleCard_card__3j21s","avatar":"SimpleCard_avatar__3_gKk","shadow":"SimpleCard_shadow__AU9Eg","imgContainer":"SimpleCard_imgContainer__xotly"};